import React, { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { myRoutes, Route as RouteType } from "./utils/routes";
import { BrowserRouter as Router } from "react-router-dom";
import { PageLayout } from "./common/PageLayout";

const renderRoutes = (routes: RouteType[]) => {
  return routes.map((route) =>
    route.component ? (
      <Route key={route.path} path={route.path} element={<route.component />} />
    ) : null
  );
};

const App = () => {
  return (
    <Router>
      <PageLayout>
        <Routes>
          {renderRoutes(myRoutes)}
          {/* Redirect unknown routes to the main page */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </PageLayout>
    </Router>
  );
};

export default App;
